import Service from "./Service";

class BusStationApiService extends Service {
  constructor() {
    super("api/BusStations");
  }

  async getAll() {
    let result = await this.get(``, (status, data) => {
      return data;
    });
    result.data = result.data.map((item) => {
      return { ...item, name: item.longName };
    });
    return result;
  }

  async getAllStopsOnLine(lineNumber) {
    let result = await this.get(`?lineNumber=${lineNumber}`, (status, data) => {
      return data;
    });
    return result;
  }

  async getTrainStations() {
    let result = await this.get(`/GetTrainStations`, (status, data) => {
      return data;
    });
    return result;
  }

  async getLines() {
    let result = await this.get(`/GetLines`, (status, data) => {
      return data;
    });
    return result;
  }

  async getDepartureTimeList(departureStationId, arrivalStationId, lineNumber, departureDate) {
    let result = await this.get(`/GetDepartureTimeList?lineNumber=${lineNumber}&departureStationId=${departureStationId}&arrivalStationId=${arrivalStationId}&departureDate=${departureDate}`, (status, data) => {
      return data;
    });
    return result;
  }

  async getDistance(departureStationId, arrivalStationId, departureDate) {
    let result = await this.get(`/GetDistance?departureStationId=${departureStationId}&arrivalStationId=${arrivalStationId}&departureDate=${departureDate}`, (status, data) => {
      return data;
    });
    return result;
  }
}

export default new BusStationApiService();
